import { foldGerman } from '@frisk/shared';
import { api } from '../api';
import { kicker, screenTitle, t } from '../theme';
import { useStore } from '../store';

export function Shopping() {
  const shopping = useStore((s) => s.shopping);
  const items = useStore((s) => s.items);
  const refresh = useStore((s) => s.refresh);
  const flash = useStore((s) => s.flash);

  const open = shopping.filter((r) => !r.done).length;

  // "LÄUFT AB — NACHKAUFEN?": anything urgent that is not already listed.
  const rules = useStore((s) => s.rules);
  /** Same containment test the server uses, so the tag agrees with reality. */
  const ruleFor = (name: string) => {
    const folded = foldGerman(name);
    return rules.find((rule) => folded.includes(rule.matchKey)) ?? null;
  };

  const listed = new Set(shopping.map((r) => r.name));
  const suggestions = items
    .filter((i) => i.expiry.tone === 'urgent' && !listed.has(i.name))
    .slice(0, 6);

  const toggle = async (id: string, done: boolean) => {
    await api.toggleShopping(id, done);
    await refresh('shopping');
  };

  const add = async (name: string) => {
    await api.addShopping(name);
    await refresh('shopping');
    flash(`${name} → Einkaufsliste`);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '34px 38px 30px' }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 24 }}>
        <div>
          <div style={kicker}>{open} OFFEN · {shopping.length - open} ERLEDIGT</div>
          <div style={screenTitle}>Einkaufsliste</div>
        </div>
        <div
          className="press"
          onClick={async () => {
            await api.clearDoneShopping();
            await refresh('shopping');
            flash('Erledigte entfernt');
          }}
          style={{ height: 62, padding: '0 24px', borderRadius: 16, border: t.hairlineStrong, display: 'flex', alignItems: 'center', fontSize: 20, fontWeight: 500, color: 'oklch(0.8 0.015 70)' }}
        >
          Erledigte löschen
        </div>
      </div>

      {suggestions.length > 0 && (
        <div style={{ marginTop: 22, borderRadius: 22, background: t.surface, border: t.hairline, padding: '18px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{ fontFamily: t.mono, fontSize: 12, letterSpacing: '0.14em', color: t.inkFaint, flex: 'none' }}>
            LÄUFT AB — NACHKAUFEN?
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {suggestions.map((s) => (
              <div
                key={s.id}
                className="press"
                onClick={() => void add(s.name)}
                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 18px', borderRadius: 999, background: t.control, fontSize: 19, fontWeight: 500 }}
              >
                <span style={{ color: t.accent, fontSize: 21 }}>+</span>
                {s.name}
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', marginTop: 18 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: 12 }}>
          {shopping.map((row) => (
            <div
              key={row.id}
              className="press"
              onClick={() => void toggle(row.id, !row.done)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: '18px 20px',
                borderRadius: 20,
                background: t.surface,
                border: t.hairline,
                opacity: row.done ? 0.5 : 1,
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 12,
                  flex: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 22,
                  background: row.done ? t.accent : 'transparent',
                  color: t.accentInk,
                  border: row.done ? 'none' : t.hairlineStrong,
                }}
              >
                {row.done ? '✓' : ''}
              </div>
              <div style={{ fontSize: 24, fontWeight: 500, textDecoration: row.done ? 'line-through' : 'none', minWidth: 0 }}>
                {row.name}
              </div>
              {/* An entry that appeared by itself is unsettling; one that says
                  why is a feature — and it is the way back to the rule.
                  Matched against the rules rather than row.source, because a
                  Bring-mirrored row is legitimately sourced 'bring'. */}
              {ruleFor(row.name) && (
                <div
                  style={{
                    marginLeft: 'auto',
                    flex: 'none',
                    fontFamily: t.mono,
                    fontSize: 12,
                    letterSpacing: '0.08em',
                    padding: '5px 11px',
                    borderRadius: 999,
                    background: 'oklch(0.28 0.012 60)',
                    color: t.inkFaint,
                    whiteSpace: 'nowrap',
                  }}
                >
                  AUTOMATISCH
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
